(() => {
  var __defProp = Object.defineProperty;
  var __defProps = Object.defineProperties;
  var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

  // src/shop-fetch.ts
  window.HotelCollection = window.HotelCollection || {};
  window.HotelCollection.shopFetch = /* @__PURE__ */ (() => {
    const controllers = /* @__PURE__ */ new Map();
    const supersede = async (key, url, options = {}) => {
      var _a;
      (_a = controllers.get(key)) == null ? void 0 : _a.abort("superseded");
      const ctrl = new AbortController();
      controllers.set(key, ctrl);
      try {
        const r = await fetch(url, __spreadProps(__spreadValues({}, options), { signal: ctrl.signal }));
        controllers.delete(key);
        if (!r.ok) throw new Error(`${r.status}`);
        return r;
      } catch (err) {
        controllers.delete(key);
        if (err.name === "AbortError") return null;
        throw err;
      }
    };
    return {
      supersede,
      html: (key, url, options) => supersede(key, url, options).then((r) => r ? r.text() : null),
      json: (key, url, options) => supersede(key, url, options).then(
        (r) => r ? r.json() : null
      )
    };
  })();
  window.__shopFetch = window.HotelCollection.shopFetch;
})();
